export class OfflineError extends Error {
  message = 'You appear to be offline.';
}
